module.exports = __webpack_public_path__ + "img/GAME_MULTI JANGGI.7175e020.png";